import { config as DevConfig } from "./Config.development";
import { config as TestConfig } from "./Config.test";
import { config as ProdConfig } from "./Config.production";

const env = process.env.REACT_APP_ENV;

export default env === "PROD" ? ProdConfig : env === "TEST" ? TestConfig : DevConfig;
